import videojs from 'video.js';
import PluginTech from './plugin-tech';

const mergeOptions = videojs.mergeOptions;

/**
 * Технология воспроизведения через VLC Web Plugin.
 */
class Vlc extends PluginTech {
  static get pluginType() {
    return 'application/x-vlc-plugin';
  }

  constructor(options, ready) {
    // Дополнительные атрибуты embed тега
    options.attributes = mergeOptions({
      type: Vlc.pluginType,
      controls: 'true',
    }, options.attributes);

    super(options, ready);
  }

  attachPluginEvents() {
    this.el_.addEventListener('MediaPlayerOpening', () => {
      this.trigger('loadstart');
    });
    this.el_.addEventListener('MediaPlayerBuffering', () => {
      this.trigger('loadeddata');

      // Notify video.js to refresh some data from VLC
      this.trigger('volumechange');
    });
    this.el_.addEventListener('MediaPlayerPlaying', () => {
      this.trigger('play');
      this.trigger('playing');
    });
    this.el_.addEventListener('MediaPlayerPaused', () => {
      this.trigger('pause');
    });
    this.el_.addEventListener('MediaPlayerStopped', () => {
      this.trigger('pause');
      this.trigger('ended');
    });
    this.el_.addEventListener('MediaPlayerEncounteredError', () => {
      this.trigger('error');
      this.trigger('ended');
    });
    this.el_.addEventListener('MediaPlayerEndReached', () => {
      this.trigger('pause');
      this.trigger('ended');
    });
    this.el_.addEventListener('MediaPlayerTimeChanged', () => {
      this.trigger('timeupdate');
    });
    this.el_.addEventListener('MediaPlayerPositionChanged', () => {
      this.trigger('progress');
    });
    this.el_.addEventListener('MediaPlayerLengthChanged', () => {
      this.trigger('durationchange');
    });
  }

  //noinspection JSUnusedGlobalSymbols
  src(src) {
    if (src === undefined) {
      return this.currentSrc();
    }

    // Setting src through `src` not `setSrc` will be deprecated
    return this.setSrc(src);
  }

  setSrc(src) {
    src = PluginTech.getAbsoluteUrl(src);
    this.el_.playlist.items.clear();
    this.el_.playlist.add(src);
  }

  currentSrc() {
    if (this.currentSource_) {
      return this.currentSource_.src;
    }
    else {
      return this.el_.playlist.items[this.el_.playlist.currentItem];
    }
  }

  play() {
    this.el_.playlist.play();
  }

  pause() {
    this.el_.playlist.pause();
  }

  paused() {
    const state = this.el_.input.state;
    return (state === 4 /* PAUSED */ || state === 6 /* ENDED */);
  }

  currentTime() {
    return (this.el_.input.time / 1000);
  }

  setCurrentTime(seconds) {
    this.el_.input.time = (seconds * 1000);
  }

  duration() {
    return (this.el_.input.length / 1000);
  }

  buffered() {
    // Not supported
    return [];
  }


  ended() {
    const state = this.el_.input.state;
    return (state === 6 /* ENDED */ || state === 7 /* ERROR */);
  }

  volume() {
    return this.el_.audio.volume / 100;
  }

  setVolume(percentAsDecimal) {
    if (percentAsDecimal) {
      this.el_.audio.volume = percentAsDecimal * 100;
    }
  }

  muted() {
    return this.el_.audio.mute;
  }

  setMuted(muted) {
    this.el_.audio.mute.mute = muted;
  }

  supportsFullScreen() {
    return true;
  }

  enterFullScreen() {
    this.el_.video.fullscreen = true;
    this.trigger('fullscreenchange');
  }

  exitFullScreen() {
    this.el_.video.fullscreen = false;
    this.trigger('fullscreenchange');
  }

  isPluginReady() {
    return 1 &&
      typeof this.el_.input !== 'undefined' &&
      typeof this.el_.audio !== 'undefined' &&
      typeof this.el_.video !== 'undefined' &&
      typeof this.el_.playlist !== 'undefined';
  }

  static isSupported() {
    return super.isPluginAvailable(Vlc.pluginType);
  }
}

videojs.registerTech('Vlc', Vlc);
export default Vlc;



// WEBPACK FOOTER //
// ./src/players/vlc-tech.js